<template>
  <div class="commandBar">
    <input type="text" id="commandBar" v-bind:placeholder="getPlaceholder()" autofocus="" v-model="cmdBarText" v-on:keyup.enter="parseCommand"></input>
  </div>
</template>

<style scoped>
#commandBar {
  top:0px;
  width:100%;
}
input {
  font-size: 1em;
}
</style>

<script lang="js">
import { Component, Vue } from 'vue-property-decorator';
import * as DateTime from '@/common/DateTime';
import Task from '@/common/Task';
import * as Graph from '@/common/Graph';
import store from '@/store/Store';

//valid command patterns:
// help
// help task
// help edge
// print
// draw
// clear
// save
// load
// title change the window title to
//   changes the window title to "Tasker: change the window title to"
//
// task add do laundry 190203 1
// task add do laundry 20190203 1
// task edit 3
//   spawns 3 popups to change name / due date / hours planned
// task del 3
//
// edge add 1 3
// edge del 1 3

export default @Component({
})
class CommandBar extends Vue {
  //data:
  message="hellow";
  cmdBarText = '';
  cmdBarPlaceholder = 'Welcome to Tasker, type a <command> or <help>';
  getPlaceholder(){
    return this.cmdBarPlaceholder;
  }

  created(){//https://medium.com/haiiro-io/why-i-use-vue-class-component-472579a266b4
    console.log('CommandBar created');
  }
  mounted(){
    console.log('CommandBar mounted');
    this.cmdBarText = '';
    // this.cmdBar.focus();
    this.$title = store.getters.getWindowTitle;
  }
  updated(){
    // console.log('updated: commandBarText = ' + this.cmdBarText);
    // let c = this.cmdBarText;
    //
    // //task add do something important 190409 2
    // if (c.match(/task .*/)){
    //   console.log('handle task');
    // }
  }

  beforeMount(){
    console.log('CommandBar beforeMount');
  }
  destroyed(){
    console.log('CommandBar destroyed');
  }

  parseCommand(){
    let cmd = this.cmdBarText;
    console.log('parseCommand(' + cmd + ')');
    // console.log('zoom is ' + DS.cyt.zoom());

    if (cmd.match(/task .*/)){
      // console.log('matched task');
      this.handleTask(cmd);
    }
    else if (cmd.match(/edge .*/)){
      // console.log('matched edge');
      this.handleEdge(cmd);
    }
    // else if (cmd.match(/work .*/)){
    //   console.log('matched work');
      // this.handleWork(cmd);
    // }
    else if (cmd.match(/help.*/)){
      // console.log('matched help');
      this.handleHelp(cmd);
    }
    else if (cmd.match(/title .*/)){
      // console.log('matched title');
      this.handleTitle(cmd);
    }
    //should guard these so that we don't trigger on any mention of print/clear/sae/load
    else if (cmd.match(/print/)){
      // console.log('matched print');
      this.handlePrint();
    }
    else if (cmd.match(/clear/)){
      // console.log('matched clear');
      this.handleClear();
    }
    else if (cmd.match(/save/)){
      // console.log('matched save');
      this.handleSave();
    }
    else if (cmd.match(/load/)){
      // console.log('matched load');
      this.handleLoad();
    }
    else if (cmd.match(/draw/)){
      // console.log('matched draw');
      // Graph.drawGraph(); //this always happens, so just finish the command
      this.resetCommandBar();
    }
    else if (cmd.match(/about/)){
      // console.log('matched draw');
      this.handleAbout();
      this.resetCommandBar();
    }
    else {
      let msg = 'Did not recognize command [' + cmd + ']';
      Vue.$log.info(msg);
      this.changeCommandBarLabel(msg);
    }

    Graph.drawGraph();
    console.log('command done');
  }//parseCommand

  handleTask(cmd){
    // console.log('handleTask(' + cmd + ')');
    let done = false; // use done to indicate when command is finished

    var taskAddMatch = cmd.match(/task add ([a-zA-Z0-9_\-\s]+)/);
    if (!done && taskAddMatch){
      let arg = taskAddMatch[1];
      // console.log('add new task [' + arg + ']');

      //task add do thing 4 & 5 with #[5] 20190120 3
      var addparts = arg.match(/([a-zA-Z0-9_\-\s]+) ([0-9]+) ([0-9]+)/);
      // console.log(addparts);
      if (addparts != null && addparts.length == 4){ //0 = input, 1 = task name, 2 = date due, 3 = hours
        // console.log('taskAdd has parts[' + addparts[1] + '] [' + addparts[2] + '] [' + addparts[3] + ']');

        let tempDT = DateTime.dateFromString(addparts[2]);
        if (tempDT != false ){
          Graph.addTask(addparts[1], tempDT, parseInt(addparts[3]));
        }else{ //bad command
          console.log('taskdatedue give bad cmd[' + addparts[2] + ']');
        }
        done = true;
      } else {
        console.log('[' + cmd + '] is not in the accepted format of [task add any_alpha-numeric-symbolic_task_name 20190100 3]');
      }
    }//task add

    var taskDelMatch = cmd.match(/task del ([0-9]+)/);
    if (!done && taskDelMatch != null){
      // find nodes with found convenience numbers
      let tsk = parseInt(taskDelMatch[1]);
      Graph.delTask(tsk);
      done = true;
    }//task del

    var taskPuntMatch = cmd.match(/task punt ([0-9]+)/);
    if (!done && taskPuntMatch != null){
      Graph.puntTask( parseInt( taskPuntMatch[1] ));
      done = true;
    }//task punt

    //task edit 2
    var taskEditMatch = cmd.match(/task edit ([0-9]+)/);
    if (!done && taskEditMatch != null){
      // console.log('taskEditMatch', taskEditMatch);

      let tsk = Graph.getTask(parseInt(taskEditMatch[1]));
      // console.log('got task', tsk );

      if (tsk != false){
        let resp1 = window.prompt('Change name from [' + tsk.name + '] to: (Enter to keep)');
        let resp2 = window.prompt('Change due date from [' + DateTime.dateTimeToString(tsk.dateDue) + '] to [yymmdd]: (Enter to keep)');
        let resp3 = window.prompt('Change hours remaining from [' + tsk.hoursPlanned + '] to: (Enter to keep)');
        let resp4 = window.prompt('Change percent done from [' + tsk.pctDone + '] to: (Enter to keep)');
        console.log('received [' + resp1 + '] + [' + resp2 + '] [' + resp3 + '] [' + resp4 +']');

        if (resp1 != null && resp1 != ''){
          tsk.name = resp1;
        }

        if (resp2 != null && resp2 != ''){
          let respDateMatch = resp2.match(/(\d{8}|\d{6})/);//match yyyymmdd or yymmdd, putting 8 before 6 grabs full year
          // console.log('respDateMatch',respDateMatch)
          if (respDateMatch != null){
            // console.log('respDateMatch['+respDateMatch);
            let newDate = DateTime.dateFromString(respDateMatch[1]);
            tsk.dateDue = newDate;
          } else {
            console.log('New date has bad format[' + resp2 + '] vs [yymmdd | yyyymmdd], not changed');
          }
        }

        if (resp3 != null && resp3 != ''){
          let newHours = parseInt(resp3);
          if ( !isNaN(newHours)){
            tsk.hoursPlanned = newHours;
          } else {
            console.log('New hours planned has bad format[' + resp3 +'], not changed');
          }
        }
        if (resp4 != null && resp4 != ''){
          let k = parseInt(resp4);
          if ( !isNaN(k) ){
            tsk.pctDone = k;
          } else {
            console.log('New percent done has bad format[' + resp4 +'], not changed');
          }
        }

        // console.log('task edited to:', tsk);
        store.commit('updateTask', tsk);
        done = true;
      }

      // load, graph draws, then enter/etc and it blanks, print is empty...
      if (done){
        this.resetCommandBar();
      } else {
        this.helpTask();
      }
    }//task edit

    if (done){
      this.resetCommandBar();
      store.commit('renumberTasks');
      Graph.drawGraph();
    } else {
      this.helpTask();
    }
  }//handleTask

  handleEdge(cmd){
    console.log('handleEdge(' + cmd + ')');
    let done = false;

    var edgeAddMatch = cmd.match(/edge add ([0-9]+) ([0-9]+)/); //search for add edge
    if (!done && edgeAddMatch != null){
      let tp = Graph.getTask(parseInt(edgeAddMatch[1])); // find nodes with found convenience numbers
      let tc = Graph.getTask(parseInt(edgeAddMatch[2]));
      if (tp != null && tc != null){
        Graph.addEdge(tp, tc);
      }
      done = true;
    }

    var edgeDelMatch = cmd.match(/edge del ([0-9]+) ([0-9]+)/); //search for add edge
    if (!done && edgeDelMatch != null){
      let tp = Graph.getTask(parseInt(edgeDelMatch[1])); // find nodes with found convenience numbers
      let tc = Graph.getTask(parseInt(edgeDelMatch[2]));
      if (tp != null && tc != null){
        Graph.delEdge(tp, tc);
      }
      done = true;
    }

    if (done){
      this.resetCommandBar();
    }
    else {
      this.helpEdge();
    }
  }//handleEdge

  // handleWork(cmd){
  //   // console.log('handleWork');
  //   let ret = Graph.addWorkString( cmd );
  //   if (ret.succeeded){
  //     console.log('added work');
  //     this.resetCommandBar();
  //   }else {
  //     this.helpWork();
  //   }
  // }//handleWork

  handlePrint(){
    Graph.printTasks();
    this.resetCommandBar();
  }

  handleClear(){
    Graph.clearGraph();
    this.resetCommandBar();
  }

  handleSave(){
    Graph.saveJSON();
    this.resetCommandBar();
  }

  handleLoad(){
    Graph.loadJSON();
    this.resetCommandBar();
  }

  handleTitle(cmd){
    Vue.$log.info('handleTitle'+ cmd);
    var titleChangeMatch = cmd.match(/title ([a-zA-Z0-9_\-\s]+)/);
    if (titleChangeMatch){
      // console.log('titleChangeMatch',titleChangeMatch);
      this.$title = titleChangeMatch[1];
      this.resetCommandBar();
      store.commit('setWindowTitle', titleChangeMatch[1]);
    }
    else {
      this.helpTitle();
    }
  }

  handleHelp(cmd){
    this.resetCommandBar();
    let taskMatched = cmd.match(/help task/);
    let edgeMatched = cmd.match(/help edge/);
    // let workMatched = cmd.match(/help work/);
    let titleMatched = cmd.match(/help title/);

    if (taskMatched){
      this.helpTask();
    }
    else if (edgeMatched){
      this.helpEdge();
    }
    // else if (workMatched){
    //   this.helpWork();
    // }
    else if (titleMatched){
      this.helpTitle();
    }
    else {
      this.changeCommandBarLabel('Try [help <cmd>] with cmd = task, edge, print, clear, title, save -- ben@benconrad.net');
    }
  }
  helpTitle(){
    this.changeCommandBarLabel('Change the window title by [title This my verbose title]');
  }
  // helpWork(){
  //   this.changeCommandBarLabel('[work add 9 190101 0500 0700 40] for working on task 9 on Jan01 from 5-7AM resulting in 40% complete');
  // }
  helpTask(){
    this.changeCommandBarLabel('[task add do laundry 190101 1] to add a new task "do laundry" due by Jan01 expected to take 1 hour');
  }
  helpEdge(){
    this.changeCommandBarLabel('[edge add 3 9] to add an edge from task 3 to task 9, indicating task 9 follows 3');
  }

  changeCommandBarLabel(label){
    this.cmdBarPlaceholder = label; //respond via the placeholder
  }

  resetCommandBar(){
    this.cmdBarText = '';
  }

}
</script>




